import { createApp } from 'vue'
import App from '@/App.vue'
import * as store from '@/store'
import UiSpinner from '@/components/ui/Spinner'
import UiFlag from '@/components/ui/Flag'
import UiDropdown from '@/components/ui/Dropdown'

import './main.css'
import './avatars.css'

const app = createApp(App)

app.component('UiSpinner', UiSpinner)
app.component('UiFlag', UiFlag)
app.component('UiDropdown', UiDropdown)

app.mount('#app')

window.app = app
window.store = store
